import { sum } from '@/helpers/Math';
import { TixTime } from '@/TixTime/TixTime';
export function annotateSession(session, event, quantities) {
    return {
        ...session,
        annotations: getAnnotationsOrMessages(event, 'session', 'annotation', session.startTime, quantities),
    };
}
export function getDateAnnotations(date, event, quantities) {
    return getAnnotationsOrMessages(event, 'date', 'annotation', date, quantities);
}
export function getMessages(event, type, start, quantities) {
    return getAnnotationsOrMessages(event, type, 'message', start, quantities);
}
function getAnnotationsOrMessages(event, type, annotationOrMessage, start, quantities) {
    const result = [];
    const rules = event.messageRules ?? [];
    for (const rule of rules) {
        const action = getMatchingAction(rule.actions, type, annotationOrMessage);
        if (action && ruleTriggered(event, rule, type, quantities, start)) {
            result.push(action);
        }
    }
    return result;
}
function getMatchingAction(actions, type, annotationOrMessage) {
    if (type === 'quantities') {
        return actions.quantity_message;
    }
    else if (type === 'session') {
        return annotationOrMessage === 'annotation' ? actions.session_annotation : actions.session_message;
    }
    else {
        return annotationOrMessage === 'annotation' ? actions.date_annotation : actions.date_message;
    }
}
function ruleTriggered(event, rule, type, quantities, start) {
    return dateTimePassesTriggers(event, rule, type, start) && quantitiesPassesTriggers(event, rule, quantities);
}
function dateTimePassesTriggers(event, rule, type, start) {
    const triggers = rule.triggers.dateOrSession;
    if (triggers == null || triggers.length === 0) {
        return true;
    }
    else if (start == null) {
        return false;
    }
    else {
        return triggers.some((trigger) => {
            // TODO Match by session indices too.
            return (matchesDateRange(trigger, start) && matchesDaysOfWeek(trigger, start) && matchesTimeOfDay(trigger, start, type));
        });
    }
}
function matchesDateRange(trigger, sessionStart) {
    if (!trigger.dateInterval) {
        return true;
    }
    const { end, start } = trigger.dateInterval;
    return sessionStart.isBetween(start, end, undefined, '[)');
}
function matchesDaysOfWeek(trigger, sessionStart) {
    if (!trigger.weekdays) {
        return true;
    }
    return trigger.weekdays.includes(sessionStart.getDayOfWeek());
}
function matchesTimeOfDay({ time_of_day }, sessionStart, type) {
    if (!time_of_day || type === 'date') {
        return true;
    }
    const session = sessionStart.asMinutesSinceMidnight();
    const start = new TixTime(time_of_day.start).asMinutesSinceMidnight();
    const end = new TixTime(time_of_day.end).asMinutesSinceMidnight();
    return session >= start && session < end;
}
function quantitiesPassesTriggers(event, rule, quantities = {}) {
    const triggers = rule.triggers.quantity;
    if (triggers === undefined || triggers.length === 0) {
        return true;
    }
    else {
        return triggers.every((trigger) => quantitiesMatch(event, trigger, quantities));
    }
}
function ticketTypeQuantitiesMatch(trigger, quantities, types) {
    const matchingTypes = entitiesMatchingTrigger(types, trigger.ticket_type_ids, trigger.ticket_type_names);
    const selectedQuantities = sum(matchingTypes.map((type) => quantities[type.id]?.quantity ?? 0));
    return isWithinBounds(trigger, selectedQuantities);
}
function quantitiesMatch(event, trigger, quantities) {
    const types = getRelevantTicketTypes(event, trigger);
    return ticketTypeQuantitiesMatch(trigger, quantities, types);
}
function getRelevantTicketTypes(event, trigger) {
    const matchingGroups = entitiesMatchingTrigger(event.ticketGroups, trigger.ticket_group_ids, trigger.ticket_group_names);
    return matchingGroups.flatMap((t) => t.types);
}
function entitiesMatchingTrigger(entities, idFilter, nameFilter) {
    if (!idFilter?.length && !nameFilter?.length) {
        return entities;
    }
    return entities.filter((entity) => {
        return idFilter?.includes(entity.id) || nameFilter?.includes(entity.name);
    });
}
function isWithinBounds({ min, max }, totalSelected) {
    const withinMinBounds = min === undefined || totalSelected >= min;
    const withinMaxBounds = max === undefined || totalSelected <= max;
    return withinMinBounds && withinMaxBounds;
}
